module.exports = __webpack_public_path__ + "static/img/future4.5a79acb8.png";